import React from "react";
import SimplePage from "../../components/legal/SimplePage";
import { useCurrency } from "../../context/CurrencyContext";

export default function About() {
  const { settings } = useCurrency();
  return <SimplePage eyebrow="Company" title="About RydeXpress" text={settings?.content_about} loading={!settings?.content_about} />;
}
